<script lang="ts">
  import { Dialog, Tabs } from 'bits-ui';

  import type { TeoHelpTopic } from '@/teoCore/TeoHelp';

  import DialogHeader from './DialogHeader.svelte';
  import HelpTabs from './HelpTabs.svelte';

  let {
    helpData,
    onClose,
  }: {
    helpData: Promise<TeoHelpTopic> | null;
    onClose?: () => void;
  } = $props();

  function handleOpenChange(open: boolean) {
    if (!open) {
      onClose?.();
    }
  }
</script>

{#if helpData !== null}
  <Dialog.Root open={!!helpData} onOpenChange={handleOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay class="fixed inset-0 z-50 bg-white/30 backdrop-blur-xs" />
      <Dialog.Content
        preventScroll
        class="outline-hidden fixed left-1/2 top-1/2 z-50 max-h-[440px] w-[640px] translate-x-[-50%] translate-y-[-50%] rounded-md bg-white shadow-card"
      >
        {#await helpData}
          <DialogHeader title="Loading..." />
          <HelpTabs sections={[]} />
          <Tabs.Root class="flex h-[384px] flex-row" orientation="vertical"></Tabs.Root>
        {:then data}
          {#if data}
            <!-- we need the check because it will not unmount fast enough -->
            <DialogHeader title={data.title} />
            <HelpTabs sections={data.sections} />
          {/if}
        {/await}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
{/if}
